import { render } from "./ListadoActividades.vue?vue&type=template&id=6281ee3a&scoped=true"
import script from "./ListadoActividades.vue?vue&type=script&lang=js"
export * from "./ListadoActividades.vue?vue&type=script&lang=js"

import "./ListadoActividades.vue?vue&type=style&index=0&id=6281ee3a&scoped=true&lang=css"
/* custom blocks */
import block0 from "./ListadoActividades.vue?vue&type=custom&index=0&blockType=div&class=col%20col-4"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6281ee3a"]])

export default __exports__